import React from "react";
import PropTypes from "prop-types";
import configs from "../../utils/configs";
import { ExitedRoomScreen } from "./ExitedRoomScreen";
import { TERMS } from "../../constants";

export function ExitedRoomScreenContainer({ reason, leaveRoomUrl }) {
  return (
    <ExitedRoomScreen
      showTerms={configs.feature("show_terms")}
      termsUrl={configs.link("terms_of_use", TERMS)}
      reason={reason}
      leaveRoomUrl={leaveRoomUrl}
      contactEmail={configs.translation("contact-email")}
    />
  );
}

ExitedRoomScreenContainer.propTypes = {
  reason: PropTypes.string.isRequired,
  leaveRoomUrl: PropTypes.string
};
